const de = {
  header: 'Wahlen verwalten',
  menu: {
    my: 'Meine Wahlen',
    admin: 'Wahlen verwalten'
  },
  myElections: 'Wahlübersicht',
  noElectionsFound: 'Keine Wahlen gefunden',
  notEligibleForAnyElections: 'Sie sind derzeit für keine Wahlen berechtigt.',
  noActiveElections: 'Keine aktiven Wahlen gefunden.',
  noPlannedElections: 'Keine geplanten Wahlen gefunden.',
  noEndedElections: 'Keine beendeten Wahlen gefunden.',
  total: 'gesamt',
  perPage: 'Pro Seite',
  election: 'Wahl',
  elections: 'Wahlen',
  edit: {
    header: 'Wahl bearbeiten',
    createHeader: 'Wahl erstellen',
    editSuccess: 'Wahl wurde erfolgreich bearbeitet',
    createSuccess: 'Wahl wurde erfolgreich erstellt',
    createFailed: 'Wahl konnte nicht erstellt werden',
    editFailed: 'Wahl konnte nicht bearbeitet werden',
    editButton: 'Wahl bearbeiten',
    createButton: 'Wahl erstellen',
    currentlyEditingButton: 'Wird bearbeitet...',
    currentlyCreatingButton: 'Wird erstellt...',
    cancel: 'Abbrechen',
    notEditableTooltip: 'Es dürfen nur geplante Wahlen bearbeitet werden'
  },
  info: 'Alle Felder mit * sind Pflichtfelder.',
  fields: {
    title: 'Titel',
    description: 'Beschreibung',
    electionStartDate: 'Wahlbeginn',
    electionEndDate: 'Wahlende',
    visibleStartDate: 'Sichtbar ab',
    visibleEndDate: 'Sichtbar bis',
    polyasProjectId: 'Polyas Project ID',
    polyasSharedSecret: 'Secret Key'
  },
  validation: {
    case1: 'Das Startdatum der Wahl muss vor dem Enddatum liegen.',
    case2: 'Das Startdatum der Sichtbarkeit muss vor dem Enddatum liegen',
    case3: 'Das Startdatum der Sichtbarkeit muss vor oder am Startdatum der Wahl liegen',
    case4: 'Das Enddatum der Sichtbarkeit muss nach oder am Enddatum der Wahl liegen'
  },
  detail: {
    backToElectionAdmin: 'Zurück zur Wahlverwaltung',
    errorLoadingElection:
      'Die Wahl konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
    createdBy: 'Erstellt von',
    edit: 'Bearbeiten',
    goToElectionPage: 'Zur Wahlseite',
    electionPeriod: 'Wahlzeitraum',
    visibility: 'Sichtbarkeit',
    voterParticipation: 'Wahlbeteiligung',
    votedCount: 'haben abgestimmt',
    overview: 'Übersicht',
    eligibleVoters: 'Berechtigte Wähler',
    description: 'Beschreibung',
    noDescription: 'Keine Beschreibung vorhanden',
    importVoters: 'Wähler importieren',
    importVotersDescription:
      'Importieren Sie Wähler per CSV-Datei. Die Datei muss mindestens eine E-Mail-Spalte enthalten. Bereits importierte Nutzer werden überschrieben.',
    manageVoters: 'Berechtigte Wähler verwalten',
    manageVotersDescription: 'Filtern und verwalten Sie die registrierten Wähler.',
    delete: 'Wahl löschen',
    deleteConfirm:
      'Sind Sie sicher, dass Sie diese Wahl löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteNotAllowedTooltip:
      'Wahlen können nur gelöscht werden, solange sie noch nicht für Nutzer sichtbar sind.',
    importNotAllowedTooltip:
      'Nutzer können nur importiert werden, solange die Wahl noch nicht für Nutzer sichtbar ist.'
  },
  voter: {
    import: {
      importing: 'Wähler werden importiert...',
      completed: 'abgeschlossen',
      uploadingFile: 'Datei wird hochgeladen...',
      stepUpload: 'Lade Datei hoch',
      stepSearch: 'Suche nach Benutzern',
      stepDuplicates: 'Erkenne Duplikate',
      stepSave: 'Speichere Daten',
      bulkUploadFailedWithCause: `Der Import der Wähler ist fehlgeschlagen.`,
      processingBackground: 'Wird im Hintergrund verarbeitet...',
      processingTimeout:
        'Die Verarbeitung dauerte länger als erwartet. Bitte versuchen Sie es erneut.',
      processingFile: 'Datei wird verarbeitet...',
      dragCsvHere: 'CSV-Datei hierher ziehen',
      orClickToSelect: 'oder klicken um eine Datei auszuwählen',
      requiredColumns: 'Erforderliche Spalte: E-Mail, Wahlgruppe',
      errorProcessing: 'Fehler beim Verarbeiten',
      fileReadError: 'Fehler beim Lesen der Datei',
      onlyCsvAllowed: 'Bitte nur CSV-Dateien hochladen.',
      valid: 'gültig',
      invalid: 'ungültig',
      faultyUsers: 'Fehlerhafte Nutzer',
      couldNotBeImported: 'Konnten nicht importiert werden',
      duplicateUsers: 'Doppelte Nutzer',
      duplicateUsersDescription: 'Es wurde nur jeweils ein Nutzer importiert.',
      rowA: 'Reihe A',
      emailA: 'E-Mail A',
      rowB: 'Reihe B',
      emailB: 'E-Mail B',
      similarity: 'Ähnlichkeit (0-10)',
      status: 'Status',
      email: 'E-Mail',
      firstName: 'Vorname',
      lastName: 'Nachname',
      note: 'Hinweis'
    },
    table: {
      noVoters: 'Keine Wähler vorhanden',
      addVotersHint: 'Fügen Sie berechtigte Wähler hinzu, um diese Wahl durchführen zu können.',
      votingGroups: 'Wahlgruppen',
      voted: 'Abgestimmt',
      pending: 'Ausstehend',
      markedAt: 'Markiert am'
    },
    management: {
      voters: 'Wähler',
      voted: 'abgestimmt',
      pending: 'ausstehend',
      polyasExport: 'Polyas Export',
      searchPlaceholder: 'Nach Name oder E-Mail suchen...',
      status: 'Status',
      allStatuses: 'Alle Status',
      votedStatus: 'Abgestimmt',
      pendingStatus: 'Ausstehend',
      showing: 'Zeige',
      of: 'von',
      votersCount: 'Wählern'
    }
  },
  status: {
    all: 'Alle',
    active: 'Aktiv',
    planned: 'Geplant',
    finished: 'Beendet'
  },
  userElection: {
    voted: 'Abgestimmt',
    electionActive: 'Die Wahl ist aktiv. Klicken Sie auf den Button, um abzustimmen.',
    voteNow: 'Jetzt abstimmen',
    electionStartsAt: 'Die Wahl beginnt am',
    electionEnded: 'Diese Wahl ist beendet. Sie haben nicht abgestimmt.',
    remindersActive: 'Erinnerungen aktiv',
    noReminders: 'Keine Erinnerungen',
    markAsVoted: 'Als abgestimmt markieren',
    goToVoting: 'Zur Abstimmung wechseln',
    redirectToExternal:
      'Sie werden zur externen Wahlplattform weitergeleitet, um Ihre Stimme abzugeben. Ihr personalisierter Link authentifiziert Sie automatisch.',
    cancel: 'Abbrechen',
    goToVotingButton: 'Zur Abstimmung'
  },
  myElectionsPage: {
    pendingVotes: 'Ausstehende Abstimmungen',
    pendingVotesDescription:
      'Sie haben {{count}} aktive Wahl{{plural}}, bei{{plural2}} denen Sie noch nicht abgestimmt haben.'
  },
  list: {
    voted: 'abgestimmt',
    edit: 'Bearbeiten'
  }
};

export default de;
export type PolyasTranslation = typeof de;
